import fetch from "auth/FetchInterceptor";

const SearchService = {};

SearchService.searchPatient = function (searchParams) {
  return fetch({
    url: `/searchPatient?searchKeyword=${searchParams.value}&page=${searchParams.page}`,
    method: "get",
  });
};

export default SearchService;
